module.exports = __webpack_public_path__ + "static/media/travel-black-icon.844bd5d1.svg";